// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.OQemxxDkKgqObr59{text-align:center}.IRybUCgoIdo4vraJ{display:flex;justify-content:center;column-gap:8px;width:100%}`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"message": `OQemxxDkKgqObr59`,
	"buttons": `IRybUCgoIdo4vraJ`
};
export default ___CSS_LOADER_EXPORT___;
